import Dialog, {DialogCloseEventArgs} from "../../1. Core/Controls/Dialog/Dialog";
import NP from "../../1. Core/NP";
import Delegate from "../../1. Core/Delegate";
import Control from "../../1. Core/Control";
import TextField from "../../1. Core/Controls/TextField/TextField";
import {ServerAPI} from "../../1. Core/ServerAPI";
import TimeEdit, {TimeEditMode} from "../../1. Core/Controls/TimeEdit/TimeEdit";
import DateInput from "../../1. Core/Controls/DateInput/DateInput";
import {PushSchedule} from "./types";
import IconSelect from "../../1. Core/Controls/Select/IconSelect";

let moment = require('moment');

export default class EditPushScheduleDlg extends Dialog {
    public EvUserCreated: Delegate;

    private _title: Control;
    private _body: Control;
    private _dateInput: DateInput;
    private _Date: Date;
    private _timeInput: TimeEdit;
    private _Item: PushSchedule;
    private _dateFilterCombo: IconSelect;
    private _hasSubCombo: IconSelect;
    private _device: IconSelect;

    constructor(settings?: object) {
        super(settings);
    }

    _initFields(settings: object) {
        this.EvUserCreated = new Delegate();
        this._Item = null;
        super._initFields(settings);
        this._Caption = 'Create push schedule';
        this._ShowHeader = true;
        this.EvOkButtonClick.add(this._OkButtonClick, this);
    }

    _render() {
        super._render();

        this.addClass('app-list-group');

        this._title = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: "Title",
            Value: this._Item.title
        });

        this._body = new TextField({
            ParentNode: this._contentNode,
            FloatingLabel: "Body",
            Value: this._Item.body
        });

        this._dateInput = new DateInput({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Date'),
            EvChanged: () => {
                this._Date = this._dateInput.getValue();
            }
        });

        this._timeInput = new TimeEdit({
            ParentNode: this._contentNode,
            Mode: TimeEditMode.HoursMinutes,
            FloatingLabel: NP.RM.getString('UTCTime'),
        })


        this._dateFilterCombo = new IconSelect({
            ParentNode: this._contentNode,
            FloatingLabel: 'Last activity date',
            Items: [
                {RK: 'All', Value: 'All', FontImage: NP.FontImages.event},
                {Content: 'Last 7 Days', Value: '7.days', FontImage: NP.FontImages.event},
                {Content: 'Last 30 Days', Value: '30.days', FontImage: NP.FontImages.event},
                {Content: 'Last 60 Days', Value: '60.days', FontImage: NP.FontImages.event}
            ],
            EvItemSelected: () => {
                this._Item.filter.dateFilter = this._dateFilterCombo.getValue()
            }
        });

        this._dateFilterCombo.setValue(this._Item.filter.dateFilter ? this._Item.filter.dateFilter : 'All')

        this._hasSubCombo = new IconSelect({
            ParentNode: this._contentNode,
            FloatingLabel: 'Has Subscription',
            Value: this._Item.filter.hasSub == null ? 'All' : this._Item.filter.hasSub ? 'Yes' : 'No',
            Items: [
                {RK: 'All', Value: 'All', FontImage: NP.FontImages.event},
                {
                    Content: 'Yes',
                    Value: 'Yes',
                    FontImage: NP.FontImages.event
                },
                {Content: 'No', Value: 'No', FontImage: NP.FontImages.event}
            ],
            EvItemSelected: () => {
                this._Item.filter.hasSub = this._hasSubCombo.getValue() == 'All' ? null : this._hasSubCombo.getValue() == 'Yes'
            }
        });

        this._hasSubCombo.setValue(this._Item.filter.hasSub == null ? 'All' : this._Item.filter.hasSub ? 'Yes' : 'No')

        this._device = new IconSelect({
            ParentNode: this._contentNode,
            FloatingLabel: 'Filter',
            Items: [
                {Content: 'All', Value: 'all', FontImage: NP.FontImages.event},
                {Content: 'Exclude bots', Value: 'no-bots', FontImage: NP.FontImages.event},
                {Content: 'Bots', Value: 'bots', FontImage: NP.FontImages.event},
                {Content: 'Android', Value: 'android', FontImage: NP.FontImages.event},
                {Content: 'Apple', Value: 'apple', FontImage: NP.FontImages.event},
                {Content: 'Web', Value: 'web', FontImage: NP.FontImages.event},
            ],
            EvItemSelected: () => {
                this._Item.filter.device = this._device.getValue()
            }
        });

        this._device.setValue(this._Item.filter.device || 'all')

        let date = moment(this._Item.pushTS)
        if (date.isValid()) {
            this._dateInput.setValue(date.toDate());
            this._timeInput.setValue(date.format('HH:mm'));
        }
    }

    async _OkButtonClick(sender: object, args: DialogCloseEventArgs) {
        args.IsCancelClose = true;
        if (this._title.getValue() && this._body.getValue()) {

            let payload = {
                title: this._title.getValue(),
                body: this._body.getValue(),
                pushTS: moment(this._dateInput.getValue()).format('YYYY-MM-DD') + " " + this._timeInput.getValue() + ":00",
                filter: this._Item.filter,
            }

            if (this._Item.id)
                await ServerAPI.post(`/push-schedule/${this._Item.id}`, payload)
            else
                await ServerAPI.post("/push-schedule", payload)
            this.EvUserCreated.fire(this);
            this.hide();
        }
    }
}